
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'groups-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('groupsListing'), [
          translate('members'),
        ]);
        loading.value = true;

        await store.dispatch(Actions.GET_GROUPS);
        loading.value = false;
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_GROUPS_STORE);
      });

      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('name'),
          key: 'title',
          sortable: true,
        },
        {
          name: translate('rolesCount'),
          key: 'rolesCount',
          sortable: true,
        },
        /*
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },*/
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const toggleStatusGroup = async (group) => {
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_GROUP, group.id);
          await store.dispatch(Actions.GET_GROUPS);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          }
        }
      };

      const editGroup = (id) => {
        router.push({ name: 'groups-editing', params: { id } });
      };

      const createRole = (id) => {
        router.push({ name: 'roles-creating', params: { id } });
      };

      const editRole = (id) => {
        router.push({ name: 'roles-listing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_GROUP_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_GROUPS);
        loading.value = false;
      };

      return {
        tableData: computed(() => store.getters.groupsList),
        tableHeader,
        toggleStatusGroup,
        translate,
        totalItems: computed(() => store.getters.groupsListCount),
        pageChanged,
        createRole,
        editRole,
        goTo,
        editGroup,
        loading,
        can,
      };
    },
  });
